import { WarningOutlined } from '@ant-design/icons';
import './DangerFlashingTag.css';
import React from 'react';

const DangerFlashingTag = () => {


    return(
        <div
        className='flashing-warning'
        style={{
            display:'flex',
            flexDirection:'row',
            gap:'12px',
            height:'35px',
        }}
        >
            <WarningOutlined style={{ fontSize:'24px', color:'red' }} />
            <p style={{ marginLeft:'8px', color:'red', fontWeight:'bold'}}>DANGER - KEEP CLEAR OF MOVING PARTS!</p>
        </div>
    )
}

export default DangerFlashingTag;